/**
 * Прочие — 12 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ПРОЧИЕ = [
    // ── Амурские вселенцы ──
    {
        id: 'rotan',
        семейство: 'прочие',
        latin: 'Perccottus glenii',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.5,
        typicalKg: 0.08,
        typicalLengthM: 0.14,
        depthM: 1,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'массовая',
        когда: 'дневная',
        вода: { мин: 3, опт: 20, макс: 32 },
        течение: 'стоячая',
        держится: ['трава', 'ил', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'мясо', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    // ── Наши воды ──
    {
        id: 'burbot',
        семейство: 'прочие',
        latin: 'Lota lota',
        повадка: 'засадный',
        minKg: 0.3,
        maxKg: 12,
        typicalKg: 1.2,
        typicalLengthM: 0.5,
        depthM: 8,
        depthBandM: 4,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 1, опт: 4, макс: 12 },
        течение: 'любое',
        держится: ['яма', 'камни', 'коряги'],
        стая: 'одиночка',
        нерест: { с: 12, по: 2 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'spoon', вес: 0.2 },
        ],
    },
    {
        id: 'eel',
        семейство: 'прочие',
        latin: 'Anguilla anguilla',
        повадка: 'донный_хищник',
        minKg: 0.2,
        maxKg: 5,
        typicalKg: 0.8,
        typicalLengthM: 0.65,
        depthM: 5,
        depthBandM: 3,
        сложение: 'змеевидное',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 9, опт: 22, макс: 28 },
        течение: 'слабое',
        держится: ['ил', 'коряги', 'трава'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'мясо', вес: 0.6 },
            { чем: 'ракушка', вес: 0.4 },
            { чем: 'рачок', вес: 0.4 },
        ],
    },
    {
        id: 'bullhead',
        семейство: 'прочие',
        latin: 'Cottus gobio',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.05,
        typicalKg: 0.015,
        typicalLengthM: 0.09,
        depthM: 1,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 2, опт: 12, макс: 18 },
        течение: 'сильное',
        держится: ['камни', 'перекат', 'твёрдое_дно'],
        стая: 'одиночка',
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'bigmouth_buffalo',
        семейство: 'прочие',
        latin: 'Ictiobus cyprinellus',
        повадка: 'карповый_силач',
        minKg: 1,
        maxKg: 20,
        typicalKg: 4,
        typicalLengthM: 0.6,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 24, макс: 32 },
        течение: 'слабое',
        держится: ['открытая_вода', 'ил', 'трава'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'пеллетс', вес: 1 },
            { чем: 'тесто', вес: 0.8 },
            { чем: 'хлеб', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'smallmouth_buffalo',
        семейство: 'прочие',
        latin: 'Ictiobus bubalus',
        повадка: 'карповый_силач',
        minKg: 0.8,
        maxKg: 15,
        typicalKg: 3,
        typicalLengthM: 0.55,
        depthM: 3.5,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 10, опт: 23, макс: 31 },
        течение: 'любое',
        держится: ['твёрдое_дно', 'бровка', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'кукуруза', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'ракушка', вес: 0.4 },
        ],
    },
    // ── Восточная Азия ──
    {
        id: 'japanese_eel',
        семейство: 'прочие',
        latin: 'Anguilla japonica',
        повадка: 'донный_хищник',
        minKg: 0.1,
        maxKg: 1.5,
        typicalKg: 0.4,
        typicalLengthM: 0.55,
        depthM: 4,
        depthBandM: 3,
        сложение: 'змеевидное',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 10, опт: 24, макс: 30 },
        течение: 'слабое',
        держится: ['ил', 'коряги', 'камни'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'мясо', вес: 0.4 },
            { чем: 'ракушка', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Северная Америка ──
    {
        id: 'striped_bass',
        семейство: 'прочие',
        latin: 'Morone saxatilis',
        повадка: 'угонщик',
        minKg: 1,
        maxKg: 20,
        typicalKg: 4,
        typicalLengthM: 0.75,
        depthM: 4,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'панцирная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'любое',
        держится: ['открытая_вода', 'бровка', 'камни'],
        стая: 'большая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
    // ── Тропики и Южное полушарие ──
    {
        id: 'nile_perch',
        семейство: 'прочие',
        latin: 'Lates niloticus',
        повадка: 'тропический_гигант',
        minKg: 2,
        maxKg: 60,
        typicalKg: 8,
        typicalLengthM: 1.1,
        depthM: 5,
        depthBandM: 3,
        сложение: 'высокотелое',
        пасть: 'панцирная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 18, опт: 27, макс: 34 },
        течение: 'слабое',
        держится: ['бровка', 'коряги', 'камни'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 3, по: 5 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
        ],
    },
    {
        id: 'barramundi',
        семейство: 'прочие',
        latin: 'Lates calcarifer',
        повадка: 'угонщик',
        minKg: 1.5,
        maxKg: 25,
        typicalKg: 6,
        typicalLengthM: 0.85,
        depthM: 3,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'панцирная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 18, опт: 29, макс: 36 },
        течение: 'слабое',
        держится: ['коряги', 'бровка', 'трава'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 10, по: 2 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'резка', вес: 0.2 },
        ],
    },
    {
        id: 'murray_cod',
        семейство: 'прочие',
        latin: 'Maccullochella peelii',
        повадка: 'засадный',
        minKg: 1,
        maxKg: 25,
        typicalKg: 4,
        typicalLengthM: 0.85,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['коряги', 'бровка', 'яма'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'arapaima',
        семейство: 'прочие',
        latin: 'Arapaima gigas',
        повадка: 'тропический_гигант',
        minKg: 10,
        maxKg: 100,
        typicalKg: 40,
        typicalLengthM: 2,
        depthM: 3,
        depthBandM: 2,
        сложение: 'тучное',
        пасть: 'кожистая',
        редкость: 'единичная',
        когда: 'дневная',
        вода: { мин: 22, опт: 28, макс: 35 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'трава', 'поверхность'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 2, по: 4 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'мясо', вес: 0.4 },
        ],
        краснокнижная: true,
    },
];
//# sourceMappingURL=misc.js.map